import React, {useEffect, useRef, useState} from 'react';
import Transition from "../mosaic/utils/Transition.jsx";
import Button from "./Button.jsx";

function Dropdown({align, title, button, children, inhibitClosing, showTitle = true}) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const trigger = useRef(null);
    const dropdown = useRef(null);

    inhibitClosing = inhibitClosing ?? false;

    // close on click outside
    useEffect(() => {
        const clickHandler = ({target}) => {
            if ((inhibitClosing ?? false) === true) return;
            if (!dropdown.current) return;
            if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({keyCode}) => {
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    return (
        <div className="relative inline-flex">
            <Button
                ref={trigger}
                variant={"outline-black"}
                aria-haspopup="true"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-expanded={dropdownOpen}
            >
                {title}
            </Button>
            <Transition
                show={dropdownOpen}
                tag="div"
                className={`origin-top-right z-10 absolute top-full left-0 right-auto min-w-56 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 pt-1.5 rounded shadow-lg overflow-hidden mt-1 ${
                    align === 'right' ? 'md:left-auto md:right-0' : 'md:left-0 md:right-auto'
                }`}
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
            >
                <div ref={dropdown} className={'px-3 pb-2'}>
                    {showTitle &&
                        <div className="text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase pt-1.5 pb-2">
                            {title}
                        </div>
                    }
                    {children}
                </div>
            </Transition>
        </div>
    );
}

export default Dropdown;